import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';
import { Stack } from '@mui/material';
import { useParams } from "react-router-dom";

import CommonCard from '../components/common_card';
import SelectCSVFile from '../components/select_csvfile';
import UploadCSVFileButton from '../components/upload_csvfile_button';
import ReportStopDialog from '../components/report_stop_dialog';
import { RequestButton } from "../style/button";
import { BoxCenterStart } from '../style/box';
import { TypographyBold } from '../style/typography';
import UploadCsvfileSteps from '../components/upload_csvfile_steps';
import MicosInstructionSteps from '../components/micos_instruction_steps';
import FullScreenCircularLoading from '../components/fullscreen_circular_loading';

const UploadCSVFile = () => {
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [error, setError] = useState("");
  const [earthquakeUUID, setEarthquakeUUID] = useState("");
  const [uploadComplete, setUploadComplete] = useState(false);
  const [selectCSV, setSelectCSV] = useState(false);
  const { uuid } = useParams();
  

  const [loading, setLoading] = useState(false);

  const handleFirstReport = () => {
    window.location.href = `/first_report/${earthquakeUUID}`;
  };

  const containerStyle = {
    spacing: { xs: 6, sm: 6, md: 10 },
    columns: 12,
    pt: { xs: 2, sm: 3, md: 10 },
    pb: { xs: 1, sm: 3, md: 10 },
    height: '100%',
    width: { xs: '90%', sm: '60%', md: '60%' }
  };

  return (
    <BoxCenterStart pb={15}>
      {loading && <FullScreenCircularLoading loading={loading} />}

      <Grid container {...containerStyle}>
        {/* ヘッダー */}
        <Grid size={12}>
          <ReportStopDialog earthquake_uuid={uuid}/>
          <CommonCard>
            <TypographyBold sx={{ textAlign: 'center', padding: '10px 0' }}>
              第１報 本報告
            </TypographyBold>
          </CommonCard>
        </Grid>

        {/* MICOS操作手順 */}
        <MicosInstructionSteps />

        {/* CSVアップロード */}
        <Grid size={12} pt={5}>
          <UploadCsvfileSteps
            stepNumber="5"
            title="CSVファイルをアップロード"
            description="STEP4でダウンロードしたCSVファイルを下記にアップロードしてください。"
          >
            <SelectCSVFile
              file={file}
              setFile={setFile}
              fileName={fileName}
              setFileName={setFileName}
              error={error}
              setError={setError}
              selectCSV={selectCSV}
            />
          </UploadCsvfileSteps>
        </Grid>

        {/* アップロード実行 */}
        <Grid size={12}>
          <UploadCsvfileSteps
            stepNumber="6"
            title="アップロードを実行"
            description="選択したファイル名が表示されていることを確認し、間違いがなければ「アップロード」をクリックしてください。"
          >
            <BoxCenterStart sx={{ pt: 5 }}>
              <UploadCSVFileButton
                file={file}
                setFile={setFile}
                setFileName={setFileName}
                setError={setError}
                setEarthquakeUUID={setEarthquakeUUID}
                setUploadComplete={setUploadComplete}
                setSelectCSV={setSelectCSV}
                setLoading={setLoading}
                earthquake_uuid={uuid}
              />
            </BoxCenterStart>
          </UploadCsvfileSteps>
        </Grid>

        {/* 業務開始 */}
        <Grid size={12}>
          <UploadCsvfileSteps
            stepNumber="7"
            title="報告書作成業務を開始"
            description="「報告書作成業務開始」ボタンをクリックし報告業務を開始してください。"
          >
            <BoxCenterStart sx={{ pt: 5 }}>
              <RequestButton
                variant="contained"
                onClick={handleFirstReport}
                disabled={!uploadComplete}
              >
                報告書作成業務開始
              </RequestButton>
            </BoxCenterStart>
          </UploadCsvfileSteps>
        </Grid>
      </Grid>
    </BoxCenterStart>
  );
};

export default UploadCSVFile;
